import * as React from 'react';
import { useTranslation } from 'react-i18next';
import { Stack, Typography } from '@mui/material';
import { t } from 'i18next';
import ReactECharts from "echarts-for-react";


function RealizedSavingsChart(props) {

    const { data, timeAggType } = props;

    const { t } = useTranslation();

    let timestamps = data.timestamps?.map(
        (item) => timeAggType !== "q"? item : (item.replace("Q1", "-01-01").replace("Q2", "-04-01").replace("Q3", "-07-01").replace("Q4", "-10-01"))
    ) ?? [];

    let series_kwh = [];

    const solarSavingsConsumption = data.data?.find((item)=>item.name === "solar_savings_consumption")?.values ?? []
    const cogenSavingsConsumption = data.data?.find((item)=>item.name === "cogen_savings_consumption")?.values ?? []
   
    series_kwh.push({
        name: t("Solar savings"),
        data: solarSavingsConsumption.map((v)=>v*1000.0),
        type:'line',
        symbol: 'none',
        lineStyle: {
            width: 4
        }
    })

    series_kwh.push({
        name: t("Cogeneration savings"),
        data: cogenSavingsConsumption.map((v)=>v*1000.0),
        type:'line',
        symbol: 'none',
        lineStyle: {
            width: 4
        }
    })

    let series_cost = [];

    const solarSavingsCost = data.data?.find((item)=>item.name === "solar_savings_cost")?.values ?? []
    const cogenSavingsCost = data.data?.find((item)=>item.name === "cogen_savings_cost")?.values ?? []
   
    series_cost.push({
        name: t("Solar savings"),
        data: solarSavingsCost,
        type:'line',
        symbol: 'none',
        lineStyle: {
            width: 4
        }
    })

    series_cost.push({
        name: t("Cogeneration savings"),
        data: cogenSavingsCost,
        type:'line',
        symbol: 'none',
        lineStyle: {
            width: 4
        }
    })


        
    let options_cost
    let options_kwh
    
    options_cost = {
        tooltip: {
            trigger: "axis",
            valueFormatter: (value) =>
                typeof value == "number" ? value.toLocaleString(navigator.language,{
                    minimumFractionDigits:2,
                    maximumFractionDigits:2
                }) : value,
        },
        grid: {
            top: '4%',
            left: '4%',
            right: '5%',
            containLabel: true,
            bottom: 25
            
        },
        legend: {
            show: true,
            bottom: 0, 
            left: "center",
            symbol: 'none'
        },
        xAxis: {
            type: 'category',
            data: timestamps,
            silent: false,
        },
        yAxis: {
            splitArea: {
                show: false,
            },
        },
        textStyle: {
            fontFamily: "Roboto, Helvetica, Arial, sans-serif" 
        },
        series: series_cost,
    };

    options_kwh = {
        tooltip: {
            trigger: "axis",
            valueFormatter: (value) =>
                typeof value == "number" ? value.toLocaleString( {
                    minimumFractionDigits: 2,
                    maximumFractionDigits: 2
                }) : value,
        },
        grid: {
            top: '4%',
            containLabel: true,
            left: '4%',
            right: '5%',
            bottom: 25
            
        },
        legend: {
            show: true,
            bottom: 0, 
            left: "center",
            symbol: 'none'
        },
        xAxis: {
            type: 'category',
            data: timestamps,
            silent: false,
        },
        yAxis: {
            splitArea: {
                show: false,
            },
        },
        series: series_kwh,
    };

    return (
        <Stack>
            <Typography paddingTop={'25px'} align="center" component="h2" variant="h6" color="primary" gutterBottom>{t("Realized savings") + " [₺]"}</Typography>
            <ReactECharts option={options_cost}/>: 
            <Typography paddingTop={'25px'} align="center" component="h2" variant="h6" color="primary" gutterBottom>{t("Realized savings") + " [kWh]"}</Typography>
            <ReactECharts option={options_kwh}/>
        </Stack>
        
    )

};




export default RealizedSavingsChart;